import React, { Fragment } from "react";
import HomeSixteenNavigation from "../../Components/home-sixteen/HomeSixteenNavigation";
// import Logo from "../../Assets/HomeSixteenLogo.png";
import GooglePlayLogo from "../../Assets/HomeSixteenGooglePlay.png";

import HomeSixteenImageOne from "../../Assets/HomeSixteenMockupImageOne.png";
import HomeSixteenImageTwo from "../../Assets/HomeSixteenMockupImageTwo.png";
import HomeSixteenImageThree from "../../Assets/HomeSixteenMockupImageThree.png";
import HomeSixteenOptimizeImage from "../../Assets/HomeSixteenOptimizeImage.jfif";
import HomeSixteenCard from "../../Components/home-sixteen/HomeSixteenCard";
import { data } from "../../Components/home-sixteen/data";
import { Link } from "react-router-dom";
import { socials } from "../../Components/Footer";
import AppLogo from "../../Components/app-logo";

const HomeSixteen = () => {
	let card = data?.map(card => <HomeSixteenCard key={card.title} {...card} />);

	return (
		<Fragment>
			<HomeSixteenNavigation />
			<main className="bg-homesixteenhero reletive h-auto overflow-hidden">
				<div className="absolute right-0 top-0">
					<svg
						width="302"
						height="221"
						viewBox="0 0 302 221"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							opacity="0.2"
							d="M441 0.5C441 122.279 342.279 221 220.5 221C98.7212 221 0 122.279 0 0.5C0 -121.279 98.7212 -220 220.5 -220C342.279 -220 441 -121.279 441 0.5ZM128.544 0.5C128.544 51.2859 169.714 92.456 220.5 92.456C271.286 92.456 312.456 51.2859 312.456 0.5C312.456 -50.2859 271.286 -91.456 220.5 -91.456C169.714 -91.456 128.544 -50.2859 128.544 0.5Z"
							fill="white"
						/>
					</svg>
				</div>
				<div className="max-w-7xl mx-auto px-4 xl:px-0 min-h-[70vh] xl:min-h-[80vh] w-full">
					<div className="flex flex-col min-h-[65vh] justify-center items-center gap-8 z-10">
						<h1 className="text-white !m-0 text-3xl sm:text-6xl xl:text-8xl font-semibold text-center">
							Never run out of data. <br className="hidden lg:block" /> Stay
							Connected!
						</h1>
						<p className="text-white !m-0 text-base sm:text-lg lg:text-xl font-medium text-center mt-2">
							In a few clicks, buy data to keep surfing the internet. You can
							buy whatever size of <br />
							data plan for whichever network you desire.
						</p>
						<div className="flex flex-col md:flex-row justify-center items-center gap-2 lg:hidden">
							<p className="text-xl sm:text-2xl font-semibold !mb-0 capitalize text-white">
								download now
							</p>
							<a
								href={process.env.REACT_APP_GOOGLE_PLAY || "#"}
								target={process.env.REACT_APP_GOOGLE_PLAY ? "_blank" : ""}
								rel="noopener noreferrer">
								<img src={GooglePlayLogo} alt="googleplay" className="w-40" />
							</a>
						</div>
					</div>
				</div>
				<div className="absolute bottom-10">
					<svg
						width="301"
						height="441"
						viewBox="0 0 301 441"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							opacity="0.2"
							d="M301 220.5C301 342.279 202.279 441 80.5 441C-41.2788 441 -140 342.279 -140 220.5C-140 98.7212 -41.2788 0 80.5 0C202.279 0 301 98.7212 301 220.5ZM-11.456 220.5C-11.456 271.286 29.7141 312.456 80.5 312.456C131.286 312.456 172.456 271.286 172.456 220.5C172.456 169.714 131.286 128.544 80.5 128.544C29.7141 128.544 -11.456 169.714 -11.456 220.5Z"
							fill="white"
						/>
					</svg>
				</div>
			</main>

			<div className="relative max-w-6xl mx-auto -top-56 md:hidden lg:block">
				<div className="h-full flex gap-3">
					<div className="w-full">
						<img src={HomeSixteenImageOne} className="w-full h-fit" alt="" />
					</div>
					<div className="w-full mt-32">
						<img src={HomeSixteenImageTwo} className="w-full h-fit" alt="" />
					</div>
					<div className="w-full">
						<img src={HomeSixteenImageThree} className="w-full h-fit" alt="" />
					</div>
				</div>
				<div className="mx-auto w-full max-w-xl mt-20">
					<div className="flex flex-col md:flex-row justify-center items-center gap-2">
						<p className="text-xl sm:text-2xl font-semibold !mb-0 capitalize text-gray-900">
							download now
						</p>
						<a
							href={process.env.REACT_APP_GOOGLE_PLAY || "#"}
							target={process.env.REACT_APP_GOOGLE_PLAY ? "_blank" : ""}
							rel="noopener noreferrer">
							<img src={GooglePlayLogo} alt="googleplay" className="w-40" />
						</a>
					</div>
				</div>
			</div>
			<section className="relative py-5">
				<div className="max-w-7xl mx-auto px-4 xl:px-0">
					<div className="text-center mx-auto max-w-4xl">
						<h1 className="text-gray-900 capitalize text-5xl font-semibold">
							our service
						</h1>
						<p className="text-base sm:text-lg font-medium text-gray-900">
							Yes, we got you covered, With {process.env.REACT_APP_AGENT_NAME}{" "}
							Enjoy a easy and fast data delivery with Optimal security and also
							enjoy the best offers and discount sales on all our products
							periodically.
						</p>
					</div>

					<div className="grid grid-cols-1 max-w-md md:max-w-full mx-auto md:grid-cols-2 lg:grid-cols-3 mt-10 gap-4">
						{card}
					</div>
				</div>
			</section>

			<section className="relative py-5">
				<div className="max-w-7xl mx-auto px-4 xl:px-0">
					<h1 className="text-gray-900 capitalize text-2xl lg:text-5xl font-semibold text-center">
						optimize your business fast and secured!
					</h1>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-10 lg:gap-4">
						<div className="grid grid-cols-1 md:grid-cols-2 col-span-2 gap-3">
							<div className="">
								<h3 className="text-xl sm:text-2xl font-semibold text-gray-900 capitalize">
									secure transactions
								</h3>
								<p className="text-lg sm:text-xl">
									We take the security of your account seriously, we are
									committed to preventing data loss or leak.
								</p>
							</div>
							<div className="">
								<h3 className="text-xl sm:text-2xl font-semibold text-gray-900 capitalize">
									24/7 customer support
								</h3>
								<p className="text-lg sm:text-xl">
									{process.env.REACT_APP_AGENT_NAME} has a team of well-trained
									customer support agents available 24/7 to assist you with any
									issues you may have. We offer multiple channels of
									communication to ensure that you can easily reach us and
									receive prompt assistance.
								</p>
							</div>
							<div className="">
								<h3 className="text-xl sm:text-2xl font-semibold text-gray-900 capitalize">
									save and convenient
								</h3>
								<p className="text-lg sm:text-xl">
									We offers the best discounts and special deals on all of our
									services, including data, airtime, and cable subscriptions.
									Stay tuned for updates on our special offers and take
									advantage of the opportunity to save on these services.
								</p>
							</div>
							<div className="">
								<h3 className="text-xl sm:text-2xl font-semibold text-gray-900 capitalize">
									awesome service
								</h3>
								<p className="text-lg sm:text-xl">
									Yes, we got you covered, With 
									{process.env.REACT_APP_AGENT_NAME} Enjoy a easy and fast data
									delivery with Optimal security and also enjoy the best offers
									and discount sales on all our products periodically.
								</p>
							</div>
						</div>

						<div className="w-full h-full col-span-full lg:col-span-1">
							<img
								src={HomeSixteenOptimizeImage}
								alt="footer logo"
								className="h-full w-full object-cover object-center"
							/>
						</div>
					</div>
				</div>
			</section>

			<section className="relative py-5">
				<div className="max-w-7xl mx-auto px-4 xl:px-0">
					<h1 className="text-gray-900 capitalize text-2xl lg:text-5xl font-semibold text-center">
						testimonial
					</h1>

					<div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-4">
						<div className="bg-gray-200 px-4 py-4 sm:py-8 sm:px-12 rounded-2xl">
							<p className="text-lg sm:text-xl font-normal text-gray-900 text-justify sm:mt-14">
								I enjoy excellent customer service and affordable telecom
								services with swift delivery daily while using this platform. If
								you ever think of making more profits in your data reselling
								business, think of {process.env.REACT_APP_AGENT_NAME}
							</p>
							<div className="flex items-center gap-3">
								<span className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-gray-100 border"></span>
								<span className="text-base sm:text-lg capitalize lg:text-2xl font-semibold text-gray-900">
									jane james
								</span>
							</div>
						</div>
						<div className="bg-gray-200 px-4 py-4 sm:py-8 sm:px-12 rounded-2xl">
							<p className="text-lg sm:text-xl font-normal text-gray-900 text-justify sm:mt-14">
								I enjoy excellent customer service and affordable telecom
								services with swift delivery daily while using this platform. If
								you ever think of making more profits in your data reselling
								business, think of {process.env.REACT_APP_AGENT_NAME}
							</p>
							<div className="flex items-center gap-3">
								<span className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-gray-100 border"></span>
								<span className="text-base sm:text-lg capitalize lg:text-2xl font-semibold text-gray-900">
									jane james
								</span>
							</div>
						</div>
						<div className="bg-gray-200 px-4 py-4 sm:py-8 sm:px-12 rounded-2xl">
							<p className="text-lg sm:text-xl font-normal text-gray-900 text-justify sm:mt-14">
								I enjoy excellent customer service and affordable telecom
								services with swift delivery daily while using this platform. If
								you ever think of making more profits in your data reselling
								business, think of {process.env.REACT_APP_AGENT_NAME}
							</p>
							<div className="flex items-center gap-3">
								<span className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-gray-100 border"></span>
								<span className="text-base sm:text-lg capitalize lg:text-2xl font-semibold text-gray-900">
									jane james
								</span>
							</div>
						</div>
						<div className="bg-gray-200 px-4 py-4 sm:py-8 sm:px-12 rounded-2xl">
							<p className="text-lg sm:text-xl font-normal text-gray-900 text-justify sm:mt-14">
								I enjoy excellent customer service and affordable telecom
								services with swift delivery daily while using this platform. If
								you ever think of making more profits in your data reselling
								business, think of {process.env.REACT_APP_AGENT_NAME}
							</p>
							<div className="flex items-center gap-3">
								<span className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-gray-100 border"></span>
								<span className="text-base sm:text-lg capitalize lg:text-2xl font-semibold text-gray-900">
									jane james
								</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			<footer className="bg-homesixteenhero">
				<div className="max-w-8xl mx-auto p-4 sm:p-0">
					<div className="lg:h-[35vh] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 lg:!gap-8">
						<div className="w-full">
							<div className="flex items-end gap-1">
								<AppLogo type="dark" height="50px" />
							</div>
							<div className="items-center space-x-6 lg:space-x-8 mt-6 hidden">
								{/* whatsapp icon */}
								<Link to="#">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M17.5012 13.7466L14.5012 12.2466C14.4126 12.2025 14.314 12.1826 14.2152 12.1888C14.1164 12.1951 14.0211 12.2273 13.9387 12.2822L12.4687 13.2619C11.7246 12.8809 11.1191 12.2754 10.7381 11.5312L11.7187 10.0622C11.7736 9.97985 11.8058 9.88448 11.8121 9.78572C11.8183 9.68696 11.7984 9.58829 11.7544 9.49969L10.2544 6.49969C10.2077 6.40583 10.1358 6.32687 10.0467 6.27171C9.95756 6.21655 9.8548 6.18738 9.74999 6.1875C8.80516 6.1875 7.89902 6.56283 7.23093 7.23093C6.56283 7.89903 6.18749 8.80517 6.18749 9.75C6.18998 11.8875 7.04021 13.9368 8.55169 15.4483C10.0632 16.9598 12.1124 17.81 14.25 17.8125C15.1948 17.8125 16.101 17.4372 16.7691 16.7691C17.4372 16.101 17.8125 15.1948 17.8125 14.25C17.8125 14.1454 17.7834 14.043 17.7284 13.954C17.6735 13.8651 17.5948 13.7933 17.5012 13.7466ZM14.25 16.6875C12.4107 16.6853 10.6475 15.9536 9.34691 14.6531C8.04636 13.3525 7.31473 11.5893 7.31249 9.75C7.31255 9.16172 7.52536 8.5933 7.91166 8.14962C8.29796 7.70594 8.83169 7.41694 9.41437 7.33594L10.6012 9.70969L9.62718 11.1703C9.576 11.2473 9.54461 11.3358 9.53578 11.4279C9.52695 11.5199 9.54095 11.6128 9.57656 11.6981C10.0938 12.9279 11.0721 13.9062 12.3019 14.4234C12.3872 14.459 12.4801 14.473 12.5721 14.4642C12.6642 14.4554 12.7526 14.424 12.8297 14.3728L14.2903 13.3988L16.6641 14.5856C16.5831 15.1683 16.2941 15.702 15.8504 16.0883C15.4067 16.4746 14.8383 16.6874 14.25 16.6875ZM12 2.4375C10.3423 2.43715 8.71298 2.86774 7.27189 3.68703C5.8308 4.50632 4.62745 5.68616 3.77989 7.11081C2.93232 8.53545 2.46967 10.156 2.43731 11.8133C2.40495 13.4707 2.804 15.108 3.59531 16.5647L2.50593 19.8337C2.42881 20.065 2.41762 20.3132 2.47361 20.5504C2.5296 20.7877 2.65056 21.0047 2.82294 21.1771C2.99532 21.3494 3.2123 21.4704 3.44956 21.5264C3.68682 21.5824 3.93499 21.5712 4.16624 21.4941L7.43531 20.4047C8.71498 21.0991 10.1363 21.4922 11.591 21.5539C13.0456 21.6156 14.4952 21.3444 15.8291 20.7608C17.1629 20.1772 18.346 19.2968 19.2879 18.1866C20.2299 17.0764 20.9059 15.7657 21.2644 14.3546C21.6229 12.9435 21.6544 11.4691 21.3566 10.044C21.0588 8.61879 20.4395 7.28044 19.5459 6.13097C18.6523 4.98149 17.508 4.05125 16.2003 3.41117C14.8926 2.77108 13.456 2.43806 12 2.4375ZM12 20.4375C10.5168 20.4379 9.05973 20.0472 7.77562 19.305C7.69001 19.2558 7.59311 19.2296 7.49437 19.2291C7.43384 19.2294 7.37374 19.2392 7.31624 19.2581L3.81093 20.4263C3.77789 20.4373 3.74244 20.4389 3.70855 20.4309C3.67465 20.4229 3.64366 20.4056 3.61903 20.381C3.59441 20.3563 3.57713 20.3253 3.56913 20.2914C3.56113 20.2576 3.56273 20.2221 3.57374 20.1891L4.74187 16.6875C4.76714 16.6118 4.77603 16.5317 4.76795 16.4523C4.75987 16.3729 4.735 16.2962 4.69499 16.2272C3.7643 14.6195 3.3902 12.7495 3.63074 10.9075C3.87127 9.06544 4.713 7.35428 6.02533 6.03945C7.33766 4.72463 9.04723 3.87965 10.8888 3.63562C12.7304 3.39159 14.601 3.76213 16.2105 4.68978C17.82 5.61742 19.0784 7.05031 19.7904 8.76612C20.5024 10.4819 20.6282 12.3848 20.1484 14.1794C19.6685 15.9741 18.6098 17.5602 17.1365 18.6917C15.6632 19.8232 13.8577 20.4369 12 20.4375Z"
											fill="white"
										/>
									</svg>
								</Link>

								{/* facebook icon */}
								<Link to="#">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M12 2.4375C10.1087 2.4375 8.25991 2.99833 6.68736 4.04907C5.11482 5.09981 3.88917 6.59327 3.16541 8.34059C2.44164 10.0879 2.25227 12.0106 2.62125 13.8656C2.99022 15.7205 3.90096 17.4244 5.2383 18.7617C6.57564 20.099 8.27951 21.0098 10.1345 21.3788C11.9894 21.7477 13.9121 21.5584 15.6594 20.8346C17.4067 20.1108 18.9002 18.8852 19.9509 17.3126C21.0017 15.7401 21.5625 13.8913 21.5625 12C21.5595 9.46478 20.5511 7.03425 18.7584 5.24158C16.9658 3.44891 14.5352 2.44048 12 2.4375ZM12.5625 20.4188V14.0625H15C15.1492 14.0625 15.2923 14.0032 15.3978 13.8977C15.5032 13.7923 15.5625 13.6492 15.5625 13.5C15.5625 13.3508 15.5032 13.2077 15.3978 13.1023C15.2923 12.9968 15.1492 12.9375 15 12.9375H12.5625V10.5C12.5625 10.0524 12.7403 9.62323 13.0568 9.30676C13.3732 8.99029 13.8025 8.8125 14.25 8.8125H15.75C15.8992 8.8125 16.0423 8.75324 16.1478 8.64775C16.2532 8.54226 16.3125 8.39918 16.3125 8.25C16.3125 8.10082 16.2532 7.95774 16.1478 7.85225C16.0423 7.74676 15.8992 7.6875 15.75 7.6875H14.25C13.5041 7.6875 12.7887 7.98382 12.2613 8.51126C11.7338 9.03871 11.4375 9.75408 11.4375 10.5V12.9375H9C8.85082 12.9375 8.70775 12.9968 8.60226 13.1023C8.49677 13.2077 8.4375 13.3508 8.4375 13.5C8.4375 13.6492 8.49677 13.7923 8.60226 13.8977C8.70775 14.0032 8.85082 14.0625 9 14.0625H11.4375V20.4188C9.25334 20.2728 7.21138 19.2837 5.74285 17.6604C4.27432 16.037 3.49419 13.9064 3.5672 11.7186C3.64021 9.53079 4.56064 7.45698 6.13413 5.93513C7.70761 4.41328 9.81097 3.56252 12 3.56252C14.189 3.56252 16.2924 4.41328 17.8659 5.93513C19.4394 7.45698 20.3598 9.53079 20.4328 11.7186C20.5058 13.9064 19.7257 16.037 18.2572 17.6604C16.7886 19.2837 14.7467 20.2728 12.5625 20.4188Z"
											fill="white"
										/>
									</svg>
								</Link>

								{/* twitter icon */}
								<Link to="#">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M19.9744 19.948L14.0287 10.6049L19.9162 4.12492C19.9735 4.07179 20.019 4.00732 20.05 3.93562C20.0809 3.86392 20.0966 3.78656 20.0961 3.70847C20.0955 3.63037 20.0786 3.55325 20.0466 3.48202C20.0146 3.41079 19.9681 3.347 19.9101 3.29473C19.852 3.24246 19.7838 3.20284 19.7096 3.1784C19.6354 3.15396 19.557 3.14523 19.4792 3.15278C19.4015 3.16032 19.3262 3.18397 19.2581 3.22221C19.19 3.26046 19.1306 3.31247 19.0837 3.37492L13.4062 9.62055L9.47811 3.44805C9.427 3.36768 9.35631 3.30161 9.27269 3.25602C9.18906 3.21044 9.09523 3.18683 8.99998 3.18742H4.49998C4.39922 3.18747 4.30032 3.21458 4.21362 3.26592C4.12692 3.31727 4.0556 3.39096 4.00712 3.47929C3.95865 3.56763 3.93479 3.66736 3.93804 3.76807C3.94129 3.86879 3.97153 3.96677 4.02561 4.0518L9.97123 13.3949L4.08374 19.8749C3.99938 19.9873 3.96013 20.1271 3.9737 20.267C3.98727 20.4068 4.05268 20.5365 4.15707 20.6306C4.26145 20.7246 4.39725 20.7762 4.53775 20.7751C4.67824 20.7741 4.81326 20.7205 4.91623 20.6249L10.5937 14.3793L14.5219 20.5518C14.573 20.6322 14.6437 20.6982 14.7273 20.7438C14.8109 20.7894 14.9047 20.813 15 20.8124H19.5C19.6007 20.8124 19.6996 20.7853 19.7863 20.7339C19.873 20.6826 19.9444 20.6089 19.9928 20.5205C20.0413 20.4322 20.0652 20.3325 20.0619 20.2318C20.0587 20.1311 20.0284 20.0331 19.9744 19.948ZM15.3084 19.6874L5.52467 4.31242H8.69155L18.4753 19.6874H15.3084Z"
											fill="white"
										/>
									</svg>
								</Link>

								{/* instagram icon */}
								<Link to="#">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M12 7.6875C11.1471 7.6875 10.3133 7.94042 9.6041 8.41429C8.89492 8.88815 8.34217 9.56167 8.01577 10.3497C7.68937 11.1377 7.60397 12.0048 7.77036 12.8413C7.93676 13.6779 8.34749 14.4463 8.9506 15.0494C9.55372 15.6525 10.3221 16.0632 11.1587 16.2296C11.9952 16.396 12.8623 16.3106 13.6503 15.9842C14.4383 15.6578 15.1118 15.1051 15.5857 14.3959C16.0596 13.6867 16.3125 12.8529 16.3125 12C16.311 10.8567 15.8562 9.76067 15.0478 8.95225C14.2393 8.14382 13.1433 7.68899 12 7.6875ZM12 15.1875C11.3696 15.1875 10.7533 15.0006 10.2291 14.6503C9.70494 14.3001 9.29639 13.8022 9.05513 13.2198C8.81388 12.6374 8.75076 11.9965 8.87375 11.3781C8.99674 10.7598 9.30032 10.1919 9.7461 9.7461C10.1919 9.30032 10.7598 8.99674 11.3781 8.87375C11.9965 8.75076 12.6374 8.81388 13.2198 9.05513C13.8022 9.29639 14.3001 9.70494 14.6503 10.2291C15.0006 10.7533 15.1875 11.3696 15.1875 12C15.1875 12.8454 14.8517 13.6561 14.2539 14.2539C13.6561 14.8517 12.8454 15.1875 12 15.1875ZM16.5 2.4375H7.5C6.1578 2.43899 4.871 2.97284 3.92192 3.92192C2.97284 4.871 2.43899 6.1578 2.4375 7.5V16.5C2.43899 17.8422 2.97284 19.129 3.92192 20.0781C4.871 21.0272 6.1578 21.561 7.5 21.5625H16.5C17.8422 21.561 19.129 21.0272 20.0781 20.0781C21.0272 19.129 21.561 17.8422 21.5625 16.5V7.5C21.561 6.1578 21.0272 4.871 20.0781 3.92192C19.129 2.97284 17.8422 2.43899 16.5 2.4375ZM20.4375 16.5C20.4375 17.5443 20.0227 18.5458 19.2842 19.2842C18.5458 20.0227 17.5443 20.4375 16.5 20.4375H7.5C6.45571 20.4375 5.45419 20.0227 4.71577 19.2842C3.97734 18.5458 3.5625 17.5443 3.5625 16.5V7.5C3.5625 6.45571 3.97734 5.45419 4.71577 4.71577C5.45419 3.97734 6.45571 3.5625 7.5 3.5625H16.5C17.5443 3.5625 18.5458 3.97734 19.2842 4.71577C20.0227 5.45419 20.4375 6.45571 20.4375 7.5V16.5ZM17.8125 7.125C17.8125 7.31042 17.7575 7.49168 17.6545 7.64585C17.5515 7.80002 17.4051 7.92018 17.2338 7.99114C17.0625 8.06209 16.874 8.08066 16.6921 8.04449C16.5102 8.00831 16.3432 7.91902 16.2121 7.78791C16.081 7.6568 15.9917 7.48975 15.9555 7.3079C15.9193 7.12604 15.9379 6.93754 16.0089 6.76623C16.0798 6.59493 16.2 6.44851 16.3542 6.3455C16.5083 6.24248 16.6896 6.1875 16.875 6.1875C17.1236 6.1875 17.3621 6.28627 17.5379 6.46209C17.7137 6.6379 17.8125 6.87636 17.8125 7.125Z"
											fill="white"
										/>
									</svg>
								</Link>

								{/* email icon */}
								<Link to="#">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M21 4.6875H3C2.85082 4.6875 2.70774 4.74676 2.60225 4.85225C2.49676 4.95774 2.4375 5.10082 2.4375 5.25V18C2.4375 18.3481 2.57578 18.6819 2.82192 18.9281C3.06806 19.1742 3.4019 19.3125 3.75 19.3125H20.25C20.5981 19.3125 20.9319 19.1742 21.1781 18.9281C21.4242 18.6819 21.5625 18.3481 21.5625 18V5.25C21.5625 5.10082 21.5032 4.95774 21.3977 4.85225C21.2923 4.74676 21.1492 4.6875 21 4.6875ZM19.5544 5.8125L12 12.7369L4.44562 5.8125H19.5544ZM20.25 18.1875H3.75C3.70027 18.1875 3.65258 18.1677 3.61742 18.1326C3.58225 18.0974 3.5625 18.0497 3.5625 18V6.52875L11.625 13.9144C11.7287 14.0092 11.8641 14.0619 12.0047 14.0619C12.1452 14.0619 12.2807 14.0092 12.3844 13.9144L20.4375 6.52875V18C20.4375 18.0497 20.4177 18.0974 20.3826 18.1326C20.3474 18.1677 20.2997 18.1875 20.25 18.1875Z"
											fill="white"
										/>
									</svg>
								</Link>
							</div>
							<ul className="list-group border-0 list-group-horizontal">
								{socials.map((item, index) => (
									<li
										key={index}
										className="list-group-item border-0 bg-transparent text-[#fff] d-flex align-items-center">
										<a
											className="text-[#fff] text-decoration-none fontReduce"
											target={"_blank"}
											rel="noreferrer"
											href={
												item?.type === "mail" && item?.url
													? `mailto:${item?.url}`
													: item?.url || "#"
											}>
											{item?.icon}
										</a>
									</li>
								))}
							</ul>
						</div>

						{/* company */}
						<div className="space-y-4">
							<h1 className="text-xl sm:text-2xl text-white font-semibold capitalize lg:text-3xl">
								company
							</h1>
							<ul className="list-none p-0 space-y-4">
								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline capitalize">
										about us
									</Link>
								</li>

								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										Terms of Service
									</Link>
								</li>

								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline capitalize">
										pricing
									</Link>
								</li>
							</ul>
						</div>

						{/* terms of service */}
						<div className="space-y-4">
							<h1 className="text-xl sm:text-2xl text-white font-semibold lg:text-3xl">
								Terms of Service
							</h1>
							<ul className="list-none p-0 space-y-4">
								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline capitalize">
										policy
									</Link>
								</li>

								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										Terms of conditions
									</Link>
								</li>

								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										Terms of Agreement
									</Link>
								</li>

								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										Privacy and Policy
									</Link>
								</li>
							</ul>
						</div>

						{/* contact us */}
						<div className="space-y-4">
							<h1 className="text-xl sm:text-2xl text-white font-semibold capitalize lg:text-3xl">
								contact us
							</h1>
							<ul className="list-none p-0 space-y-4">
								<li>
									<span className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline capitalize">
										{process.env.REACT_APP_AGENT_TELEPHONE}
									</span>
								</li>
								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										{process.env.REACT_APP_AGENT_EMAIL}
									</Link>
								</li>
								<li>
									<Link
										to="#"
										className="text-base sm:text-lg lg:text-2xl font-light text-white no-underline">
										{process.env.REACT_APP_AGENT_ADDRESS}
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<hr className="border-white border" />
				<div className="max-w-7xl mx-auto h-16 flex items-center justify-center px-4 sm:px-0">
					<p className="tracking-wider text-base sm:text-xl text-white text-center">
						Copyright @ {process.env.REACT_APP_AGENT_NAME}{" "}
						{new Date().getFullYear()}. All Rights Reserved.
					</p>
				</div>
			</footer>
		</Fragment>
	);
};

export default HomeSixteen;
